let subscriptions = {};
const getIdGenerator = () => {
  let lastId = 0;
  const getNextUniqueId = () => {
    lastId += 1;
    return lastId;
  };
  return getNextUniqueId;
};
const getNextUniqueId = getIdGenerator();

const subscribe = (eventType, callback) => {
  const id = getNextUniqueId();

  if (!subscriptions[eventType]) subscriptions[eventType] = {};

  subscriptions[eventType][id] = callback;

  return {
    unsubscribe: () => {
      delete subscriptions[eventType][id];
      if (Object.keys(subscriptions[eventType]).length === 0)
        delete subscriptions[eventType];
    }
  };
};

const clearSubscribtions = (eventType=null) => {
  if(eventType == null){
    subscriptions = {}
  } else {
    // console.log(subscriptions[eventType])
    // console.log(Object.keys(subscriptions[eventType]).length)
    if (subscriptions[eventType] != undefined && Object.keys(subscriptions[eventType]).length > 0)
        delete subscriptions[eventType];
  }
  console.log(subscriptions)
}

const publish = (eventType, arg) => {
  if (!subscriptions[eventType]) return;

  Object.keys(subscriptions[eventType]).forEach(key =>
    subscriptions[eventType][key](arg)
  );
};

export default { publish, subscribe, clearSubscribtions };


// WEBPACK FOOTER //
// ./src/store/eventbus.js